module.exports = __webpack_public_path__ + "187dde57a7d88190bf15647eaf15eb12.png";